var common = require("../../utiles/common");
require("./qrCode.less");

module.exports = {
    register: function () {
        document.createElement('qr-code')
        ko.components.register('qr-code', {
            viewModel: function (params) {
                var $this = this;

                common.fetch("/auth/idtoken/simpleQrCode", {
                    type: "GET",
                    success:function(result){
                        console.log(result)
                        $("#qrCode").html("");
                        new QRCode(document.getElementById("qrCode"), JSON.stringify(result.data));
                    }
                })
                
            },
            template: require("./qrCode.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/component/qrCode/QRCode.js
// module id = 177
// module chunks = 0